export enum UpdateCostCenterPriceStateEnums {
    open = 1,
    close = 2
}